









// import React, { useState, useMemo } from "react";
// import {
//   Box,
//   Typography,
//   CircularProgress,
//   Paper,
//   IconButton,
//   Skeleton
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import { Document, Page, pdfjs } from "react-pdf";

// import "react-pdf/dist/Page/AnnotationLayer.css";
// import "react-pdf/dist/Page/TextLayer.css";

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.mjs",
//   import.meta.url
// ).toString();

// export default function BplPdfViewer({ BPLReport }) {
//   const [numPages, setNumPages] = useState(0);
//   const [pageNumber, setPageNumber] = useState(1);

//   const file = useMemo(() => {
//     if (!BPLReport) return null;
//     return { url: BPLReport };
//   }, [BPLReport]);

//   const onLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//   };

//   if (!file) {
//     return (
//       <Typography textAlign="center" color="text.secondary">
//         No BPL PDF available
//       </Typography>
//     );
//   }

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2,
//         borderRadius: 2,
//         backgroundColor: "var(--app-surface-2)",
//         width: "100%",
//       }}
//     >
//       {/* Header */}

//       {/* PDF Viewer */}
//       {/* <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         sx={{
//           minHeight: "100%",
//         }}
//       >
//         <Document
//           file={file}
//           onLoadSuccess={onLoadSuccess}
//           loading={<Skeleton
//             variant="rectangular"
//             animation="wave"
//             sx={{
//               width: "100%",
//               height: 420,
//               borderRadius: 2,
//             }}
//           />}
//         >
//           <Page
//             pageNumber={pageNumber}
//             width={Math.min(window.innerWidth * 0.7, 700)}
//             renderAnnotationLayer={false}
//             renderTextLayer={false}
//             loading={
//               <Skeleton
//                 variant="rectangular"
//                 animation="wave"
//                 sx={{
//                   width: "100%",
//                   height: 420,
//                   borderRadius: 2,
//                 }}
//               />
//             }
//           />
//         </Document>
//       </Box> */}
//       <Box
//   sx={{
//     width: "100%",
//     maxHeight: 500,
//     overflowY: "auto",
//     overflowX: "auto",
//     display: "flex",
//     justifyContent: "center",
//     WebkitOverflowScrolling: "touch",
//   }}
// >
//   <Document
//     file={file}
//     onLoadSuccess={onLoadSuccess}
//     loading={
//       <Skeleton
//         variant="rectangular"
//         animation="wave"
//         sx={{
//           width: "100%",
//           height: 420,
//           borderRadius: 2,
//         }}
//       />
//     }
//   >
//     <Page
//       pageNumber={pageNumber}
//       width={Math.min(window.innerWidth * 0.7, 700)}
//       renderAnnotationLayer={false}
//       renderTextLayer={false}
//       loading={
//         <Skeleton
//           variant="rectangular"
//           animation="wave"
//           sx={{
//             width: "100%",
//             height: 420,
//             borderRadius: 2,
//           }}
//         />
//       }
//     />
//   </Document>
// </Box>

//       {/* Navigation */}
//       {numPages > 1 && (
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           mt={2}
//           gap={2}
//         >
//           <IconButton
//             disabled={pageNumber <= 1}
//             onClick={() => setPageNumber((p) => p - 1)}
//             sx={{
//               backgroundColor: "none"
//             }}
//           >
//             {/* <ArrowBackIosNewIcon sx={{ fontSize: "23px" }} /> */}
//             <Typography>Prev</Typography>
//           </IconButton>

//           <Typography fontWeight={500}>
//             {pageNumber} / {numPages}
//           </Typography>

//           <IconButton
//             disabled={pageNumber >= numPages}
//             onClick={() => setPageNumber((p) => p + 1)}
//             sx={{
//               backgroundColor: "none"
//             }}
//           >
//             <Typography>Next</Typography>
//             {/* <ArrowForwardIosIcon sx={{ fontSize: "23px" }} /> */}
//           </IconButton>
//         </Box>
//       )}
//     </Paper>
//   );
// }

import React from "react";
import { Box, Typography, Paper, Skeleton } from "@mui/material";

export default function BplPdfViewer({ BPLReport }) {
  if (!BPLReport) {
    return (
      <Typography textAlign="center" color="text.secondary">
        No BPL PDF available
      </Typography>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: "var(--app-surface)",
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: 520,
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "var(--app-surface)",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <iframe
          src={`${BPLReport}#navpanes=0&scrollbar=1`}
          title="BPL ECG Report"
          width="100%"
          height="100%"
          style={{
            border: "none",
            backgroundColor: "var(--app-surface)",
            touchAction: "auto",
          }}
        />
      </Box>
    </Paper>
  );
}